import request from '@/utils/request'

// 业绩榜单列表
export function performanceStatistics (query) {
  return request({
    url: '/comprehensiveStatistics/performanceList',
    method: 'get',
    params: query
  })
}
// 一带多看（客源需求列表）
export function inMoreStatisticsGuest (query) {
  return request({
    url: '/comprehensiveStatistics/inMoreStatisticsGuest',
    method: 'get',
    params: query
  })
}
// 一带多看（房源需求列表）
export function inMoreStatisticsHouse (query) {
  return request({
    url: '/comprehensiveStatistics/inMoreStatisticsHouse',
    method: 'get',
    params: query
  })
}

// 业绩榜单列表下载
export function downloadExcel (query) {
  return request({
    url: '/comprehensiveStatistics/performanceExport',
    method: 'get',
    params: query
  })
}

// 一带多看（客源需求列表）（售）
export function inMoreStatisticsGuestSale (query) {
  return request({
    url: '/comprehensiveStatistics/inMoreStatisticsGuestSale',
    method: 'get',
    params: query
  })
}

// 一带多看（房源信息列表）（售）
export function inMoreStatisticsHouseSale (query) {
  return request({
    url: '/comprehensiveStatistics/inMoreStatisticsHouseSale',
    method: 'get',
    params: query
  })
}

// 业绩报表列表
export function performanceListTotal (query) {
  return request({
      url: '/comprehensiveStatistics/performanceCount',
      method: 'get',
      params: query
  })
}

/**
 * 房源出租统计
 * @param query 请求参数
 * @returns {*}
 */
export function statisticHouseRentQuery (query) {
  return request({
    url: '/statistic/houseRent/statistics',
    method: 'get',
    params: query
  })
}

/**
 * 客源统计
 * @param query 请求参数
 * @returns {*}
 */
export function statisticClientRentQuery (query) {
  return request({
    url: '/statistic/clientRent/statistics',
    method: 'get',
    params: query
  })
}
